export default {"src":"/_next/static/media/cart.1ed54bf3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};